const de = {
  meta: {
    home: {
      title: 'Manifestify | App für Manifestation & Affirmationen',
      description:
        'Manifestify ist eine App für Manifestation und tägliche Affirmationen für iOS und Android. Erstelle dein persönliches Manifest, setze Intentionen, gestalte Vision Boards und deute deine Träume mit KI.',
    },
    blog: {
      title: 'Manifestations-Blog: Affirmationen, Guides & Methoden',
      description:
        'Fundierte Guides zum Manifestieren: tägliche Affirmationen, die 369-Methode, Vision Boards, Scripting und Traumdeutung. Neue Beiträge vom Manifestify-Team.',
    },
    notFound: {
      title: 'Seite nicht gefunden | Manifestify',
      description: 'Die gesuchte Seite existiert nicht.',
    },
    terms: {
      title: 'Allgemeine Geschäftsbedingungen | Manifestify',
      description: 'Die Nutzungsbedingungen für die Manifestify-App und -Website.',
    },
    privacy: {
      title: 'Datenschutzerklärung | Manifestify',
      description: 'Wie Manifestify deine personenbezogenen Daten erhebt, nutzt und schützt.',
    },
  },

  nav: {
    brandAria: 'Manifestify Startseite',
    mainAria: 'Hauptnavigation',
    blog: 'Blog',
    getApp: 'App holen',
    languageAria: 'Sprache wechseln',
    languageLabel: 'Sprache',
  },

  store: {
    downloadOn: 'Laden im',
    appStore: 'App Store',
    getItOn: 'JETZT BEI',
    googlePlay: 'Google Play',
    appleAria: 'Manifestify im App Store laden',
    googleAria: 'Manifestify bei Google Play holen',
  },

  home: {
    hero: {
      titleLine1: 'Manifestiere deine Träume, jeden Tag.',
      titleAccent: 'Mit Manifestify!',
      subtitle:
        'Die Manifestations-App, die deine Praxis am Leben hält: tägliche Affirmationen, ein persönliches Manifest, Vision Boards, Intentionen und KI-Traumdeutung – alles an einem Ort. Wiederhole. Glaube. Werde.',
      note: 'Kostenloser Download · iOS & Android',
    },
    features: {
      titlePre: 'Alles, was du zum ',
      titleAccent: 'Manifestieren',
      titlePost: ' brauchst',
      subtitle:
        'Eine App für deine gesamte Praxis – von der ersten Affirmation am Morgen bis zur Deutung des Traums von letzter Nacht.',
      items: [
        {
          title: 'Tägliche Affirmationen',
          text: 'Hunderte sorgfältig formulierte Affirmationen für Liebe, Geld, Gesundheit, Selbstvertrauen und inneren Frieden – jeden Tag neu für dich.',
        },
        {
          title: 'Persönliches Manifest',
          text: 'Mach aus deinen Zielen ein persönliches Manifest, das du täglich liest und festigst, damit deine Träume immer vor dir bleiben.',
        },
        {
          title: 'Intentionen setzen',
          text: 'Setze klare tägliche Intentionen und lass die App dich mit dem verbinden, was dir wirklich wichtig ist.',
        },
        {
          title: 'Vision Board',
          text: 'Gestalte ein digitales Vision Board des Lebens, das du erschaffst, und visualisiere es überall und jederzeit.',
        },
        {
          title: 'KI-Traumdeutung',
          text: 'Beschreibe deinen Traum und entdecke seine verborgenen Botschaften mit tiefgehenden, KI-gestützten Deutungen.',
        },
        {
          title: 'Energiekarten',
          text: 'Zieh jeden Tag eine Energiekarte: ein Moment der Besinnung und eine frische Portion Inspiration.',
        },
        {
          title: 'Tägliche Erinnerungen',
          text: 'Sanfte Benachrichtigungen zu den Zeiten, die du wählst – damit deine Praxis nie von Gedächtnis oder Motivation abhängt.',
        },
        {
          title: 'Themes & Hintergrundbilder',
          text: 'Schöne Themes und Hintergrundbilder, die deine Praxis persönlich und inspirierend machen.',
        },
      ],
    },
    how: {
      titlePre: 'So ',
      titleAccent: 'funktioniert',
      titlePost: ' es',
      steps: [
        {
          title: 'Setze deine Intention',
          text: 'Wähle, was du manifestieren möchtest, und baue dein persönliches Manifest aus Hunderten kuratierten Affirmationen.',
        },
        {
          title: 'Übe täglich',
          text: 'Wiederhole deine Affirmationen, visualisiere dein Vision Board und zieh deine Energiekarte. Erinnerungen halten deine Serie am Leben.',
        },
        {
          title: 'Glaube und werde',
          text: 'Beobachte, wie sich dein Fokus, dein Selbstvertrauen und deine Entscheidungen verändern, während sich deine Praxis Tag für Tag summiert.',
        },
      ],
    },
    blogTeaser: {
      titlePre: 'Lerne die Kunst der ',
      titleAccent: 'Manifestation',
      titlePost: '',
      subtitle:
        'Guides und Techniken vom Manifestify-Team, geschrieben für echte tägliche Praxis.',
      viewAll: 'Alle Artikel ansehen →',
    },
    faq: {
      titlePre: 'Häufige ',
      titleAccent: 'Fragen',
      titlePost: '',
      items: [
        {
          q: 'Was ist Manifestify?',
          a: 'Manifestify ist eine App für Manifestation und tägliche Affirmationen für iOS und Android. Sie bringt deine ganze Praxis zusammen: Affirmationen in Kategorien wie Liebe, Karriere, Fülle und Selbstvertrauen, ein persönliches Manifest, das Setzen von Intentionen, ein Vision Board, tägliche Erinnerungen, Energiekarten und KI-gestützte Traumdeutung.',
        },
        {
          q: 'Ist Manifestify kostenlos?',
          a: 'Ja. Manifestify lässt sich sowohl im App Store als auch bei Google Play kostenlos herunterladen und nutzen. Optionale Premium-Pläne schalten die komplette Affirmationsbibliothek und erweiterte Funktionen wie unbegrenzte KI-Traumdeutung frei.',
        },
        {
          q: 'Was ist Manifestation?',
          a: 'Manifestation ist die Praxis, deine Ziele durch fokussierte Aufmerksamkeit, positiven Glauben und konsequentes Handeln Wirklichkeit werden zu lassen. Zu den Techniken zählen tägliche Affirmationen, Visualisierung, Vision Boards, Scripting und die 369-Methode.',
        },
        {
          q: 'Wie funktionieren tägliche Affirmationen?',
          a: 'Affirmationen sind kurze, positive Sätze im Präsens, die du jeden Tag wiederholst. Über Wochen formen sie deinen inneren Dialog neu und richten deine Aufmerksamkeit auf Gelegenheiten, die zu deinen Zielen passen. Der Schlüssel ist Beständigkeit – deshalb hat Manifestify tägliche Erinnerungen.',
        },
        {
          q: 'Gibt es Manifestify für iPhone und Android?',
          a: 'Ja. Manifestify ist für iPhone und iPad im App Store und für Android-Geräte bei Google Play verfügbar.',
        },
        {
          q: 'Wie funktioniert die KI-Traumdeutung?',
          a: 'Du beschreibst deinen Traum in der App, und Manifestify analysiert seine Symbole, Emotionen und Themen und liefert dir sofort eine tiefgehende Deutung, die du mit deinem eigenen Kontext verfeinern kannst.',
        },
      ],
    },
    download: {
      title: 'Fang heute an zu manifestieren',
      text: 'Schließ dich den Menschen an, die jeden Morgen mit Intention beginnen. Lade Manifestify kostenlos und baue eine Praxis, die bleibt.',
    },
  },

  blog: {
    titlePre: 'Der Manifestify ',
    titleAccent: 'Blog',
    titlePost: '',
    subtitle:
      'Praktische Guides zu Manifestation, Affirmationen, Visualisierung und Traumdeutung. Alles, was du für eine tägliche Praxis brauchst, die wirkt.',
    schemaName: 'Der Manifestify Blog',
    schemaDescription:
      'Guides zu Manifestation, täglichen Affirmationen, Vision Boards, Scripting und Traumdeutung.',
    readTime: '{n} Min. Lesezeit',
  },

  post: {
    breadcrumbAria: 'Brotkrumen-Navigation',
    home: 'Startseite',
    blog: 'Blog',
    ctaTitle: 'Setze es mit Manifestify in die Praxis um',
    ctaText:
      'Tägliche Affirmationen, ein persönliches Manifest, Vision Boards, Intentionen und KI-Traumdeutung. Deine gesamte Manifestations-Praxis in einer kostenlosen App.',
    faqTitle: 'Häufige Fragen',
    relatedTitle: 'Weiterlesen',
    relatedAria: 'Ähnliche Artikel',
  },

  notFound: {
    text: 'Diese Seite gibt es nicht – deine Träume schon.',
    backHome: 'Zurück zur Startseite',
    readBlog: 'Zum Blog',
  },

  footer: {
    tagline:
      'Manifestiere deine Träume, jeden Tag. Affirmationen, Intentionen, Vision Boards und Traumdeutung in einer App.',
    exploreTitle: 'Entdecken',
    exploreAria: 'Entdecken',
    home: 'Startseite',
    blog: 'Blog',
    downloadTitle: 'App holen',
    downloadAria: 'Download',
    appStoreLink: 'iPhone & iPad (App Store)',
    playStoreLink: 'Android (Google Play)',
    legalTitle: 'Rechtliches',
    legalAria: 'Rechtliches',
    terms: 'Allgemeine Geschäftsbedingungen',
    privacy: 'Datenschutzerklärung',
    copyright: '© {year} Manifestify von Portal Studio. Alle Rechte vorbehalten.',
  },

  legal: {
    back: 'Zurück',
    translationNotice:
      'Diese Übersetzung dient nur der Verständlichkeit. Rechtlich verbindlich ist die englische Fassung dieses Dokuments.',
    lastUpdated: 'Zuletzt aktualisiert: {date}',
  },
};

export default de;
